import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import Bodymovin from 'components/bodymovin/bodymovin'

import styles from './view.scss'

class Content extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<Bodymovin
					loop={false}
					path={this.props.path}
				>
					<div styleName='animation'></div>
				</Bodymovin>
				<h1 styleName='title'>
					{this.props.title}
				</h1>
				<p styleName='description'>
					{this.props.description}
				</p>
			</div>
		)
	}
}

Content.propTypes = {
	path: PropTypes.string,
	title: PropTypes.string,
	description: PropTypes.string,
}

Content.defaultProps = {
	path: '',
	title: '',
	description: '',
}

export default CSSModules(Content, styles, {allowMultiple: true})
